<hf-named-icon *ngIf="icon" [icon]="icon"></hf-named-icon>
<ng-content></ng-content>
